import { paths } from 'config'
import { DrawerVisitorPanel } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.visitorCheckInRequests,
    canShowVisitorPanelCheckIns: true,
    exact: true,
    linkSettings: {
      icon: DrawerVisitorPanel,
      label: 'nav.visitorCheckInRequests',
      to: paths.visitorCheckInRequests,
    },
    component: Loadable({
      component: () => import('./pages/VisitorCheckInRequest'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.visitorCheckInRequest,
    canShowVisitorPanelCheckIns: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/VisitorCheckInRequestDetails'),
    }),
    layoutSettings: {},
  },
]

export default routes
